import { $t } from '@previo/core'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum MessageStatusId {
  PENDING = 1,
  RESOLVED = 2,
  ERROR = 3,
  SENT = 4,
}

export class MessageStatus extends Codebook<MessageStatusId> {
  static readonly PENDING = new MessageStatus(
    MessageStatusId.PENDING,
    () => $t('messageStatus.pending'),
    Color.WARNING,
  )
  static readonly RESOLVED = new MessageStatus(
    MessageStatusId.RESOLVED,
    () => $t('messageStatus.resolved'),
    Color.POSITIVE,
  )
  static readonly ERROR = new MessageStatus(
    MessageStatusId.ERROR,
    () => $t('messageStatus.error'),
    Color.NEGATIVE,
  )
  static readonly SENT = new MessageStatus(
    MessageStatusId.SENT,
    () => $t('messageStatus.sent'),
    Color.POSITIVE,
  )

  private constructor(
    public readonly id: MessageStatusId,
    public readonly name: () => string,
    public readonly color: Color,
  ) {
    super(id)
  }
}
